import { IRouteProps, FlowEnum } from './types';
import {
  CheckFlow,
  LocationAmount,
  CommercialSize,
  Postcode,
  BusinessType,
  ApartmentSize,
  PaymentType,
  AdditionalPayment,
  CreditPayment,
  Period,
  Delivery,
  HasLegalInsurance,
  LegalInsurance,
  Package,
  PreResult,
  HouseHold,
} from './components';
import HasUnionOptions from './components/Question/HasUnionOptions';

const routes: IRouteProps[] = [
  {
    path: '/gewerbe/standorte',
    exact: true,
    component: LocationAmount,
    nextUrl: ['/gewerbe/flaeche', 'https://www.mineko.de/kontakt-gewerbe/'],
    progress: 15,
    flow: FlowEnum.CHECK_BUSINESS,
  },
  {
    path: '/gewerbe/flaeche',
    exact: true,
    component: CommercialSize,
    nextUrl: ['/gewerbe/plz', 'https://www.mineko.de/kontakt-gewerbe/'],
    progress: 30,
    flow: FlowEnum.CHECK_BUSINESS,
  },
  {
    path: '/gewerbe/plz',
    exact: true,
    component: Postcode,
    nextUrl: '/gewerbe/rechtsschutz-fw80',
    progress: 40,
    flow: FlowEnum.CHECK_BUSINESS,
  },
  {
    path: '/gewerbe/rechtsschutz-fw80',
    exact: true,
    component: HasLegalInsurance,
    nextUrl: ['/gewerbe/rechtschutzversicherung-fw80y', '/gewerbe/paket'],
    progress: 50,
    flow: FlowEnum.CHECK_BUSINESS,
  },
  {
    path: '/gewerbe/rechtschutzversicherung-fw80y',
    exact: true,
    component: LegalInsurance,
    nextUrl: '/gewerbe/paket',
    progress: 60,
    flow: FlowEnum.CHECK_BUSINESS,
  },
  {
    path: '/gewerbe/paket',
    exact: true,
    component: Package,
    progress: 70,
    flow: FlowEnum.CHECK_BUSINESS,
  },
  {
    path: '/gewerbe',
    exact: true,
    component: BusinessType,
    nextUrl: '/gewerbe/standorte',
    progress: 8,
    flow: FlowEnum.CHECK_BUSINESS,
  },
  {
    path: '/wohnen/haushalt-fw10',
    exact: true,
    component: HouseHold,
    nextUrl: '/wohnen/wohnungsgroesse-fw20',
    progress: 10,
    flow: FlowEnum.CHECK_PRIVATE,
  },
  {
    path: '/wohnen/wohnungsgroesse-fw20',
    exact: true,
    component: ApartmentSize,
    nextUrl: '/wohnen/plz-fw30',
    progress: 10,
    flow: FlowEnum.CHECK_PRIVATE,
  },
  {
    path: '/wohnen/plz-fw30',
    exact: true,
    component: Postcode,
    nextUrl: '/wohnen/nachzahlung-oder-gutschrift-fw40',
    progress: 20,
    flow: FlowEnum.CHECK_PRIVATE,
  },
  {
    path: '/wohnen/nachzahlung-oder-gutschrift-fw40',
    exact: true,
    component: PaymentType,
    nextUrl: ['/wohnen/nachzahlung-fw40n', '/wohnen/nachzahlung-fw40g'],
    progress: 30,
    flow: FlowEnum.CHECK_PRIVATE,
  },
  {
    path: '/wohnen/nachzahlung-fw40n',
    exact: true,
    component: AdditionalPayment,
    nextUrl: '/wohnen/zeitraum-fw50',
    progress: 30,
    flow: FlowEnum.CHECK_PRIVATE,
  },
  {
    path: '/wohnen/nachzahlung-fw40g',
    exact: true,
    component: CreditPayment,
    nextUrl: '/wohnen/zeitraum-fw50',
    progress: 30,
    flow: FlowEnum.CHECK_PRIVATE,
  },
  {
    path: '/wohnen/zeitraum-fw50',
    exact: true,
    component: Period,
    nextUrl: '/wohnen/zustellung-fw51',
    progress: 40,
    flow: FlowEnum.CHECK_PRIVATE,
  },
  {
    path: '/wohnen/zustellung-fw51',
    exact: true,
    component: Delivery,
    nextUrl: ['/wohnen/rechtsschutz-fw80', '/wohnen/paket', '/wohnen/gewerkschaft'],
    progress: 50,
    flow: FlowEnum.CHECK_PRIVATE,
  },
  {
    path: '/wohnen/rechtsschutz-fw80',
    exact: true,
    component: HasLegalInsurance,
    nextUrl: ['/wohnen/rechtschutzversicherung-fw80y', '/wohnen/ergebnis'],
    progress: 60,
    flow: FlowEnum.CHECK_PRIVATE,
  },
  {
    path: '/wohnen/gewerkschaft',
    exact: true,
    component: HasUnionOptions,
    nextUrl: ['/wohnen/ergebnis', '/wohnen/paket'],
    progress: 70,
    flow: FlowEnum.CHECK_PRIVATE,
  },
  {
    path: '/wohnen/rechtschutzversicherung-fw80y',
    exact: true,
    component: LegalInsurance,
    nextUrl: ['/wohnen/ergebnis', '/wohnen/gewerkschaft'],
    progress: 70,
    flow: FlowEnum.CHECK_PRIVATE,
  },
  {
    path: '/wohnen/ergebnis',
    exact: true,
    component: PreResult,
    nextUrl: '/wohnen/paket',
    progress: 76,
    flow: FlowEnum.CHECK_PRIVATE,
  },
  {
    path: '/wohnen/paket',
    exact: true,
    component: Package,
    progress: 76,
    flow: FlowEnum.CHECK_PRIVATE,
  },
  {
    path: '/',
    exact: true,
    strict: true,
    component: CheckFlow,
    nextUrl: ['/wohnen/haushalt-fw10', '/gewerbe'],
    progress: 4,
    flow: null,
    isDefault: true,
  },
];

export default routes;
